// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.0004 2V7H9.00041V2H11.0004ZM7.00041 3V7H5.00041V3H7.00041ZM15.0004 3V7H13.0004V3H15.0004ZM2.92676 8H21.0004V13C21.0004 15.2091 19.2095 17 17.0004 17H16.0669C15.5284 18.2443 14.6199 19.2901 13.4843 20H20.0004V22H3.00041V20H6.50591C4.79741 18.9327 3.60555 17.1027 3.422 14.9613L3.42138 14.9541L2.92676 8ZM16.5754 15H17.0004C18.105 15 19.0004 14.1046 19.0004 13V10H16.9318L16.5794 14.9541L16.5788 14.9613C16.5777 14.9742 16.5766 14.9871 16.5754 15Z"}}]};

const TeaFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tea-filled',
    ref,
    icon: element,
  },
));

TeaFilledIcon.displayName = 'TeaFilledIcon';

export default TeaFilledIcon;
